import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import DiscountCodesCreateForm from './DiscountCodesCreateForm';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import Title from 'components/ui/general/Title';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import { connect } from 'react-redux';
import { createDiscountCode } from 'store/actions/discountCodes/createDiscountCodes';

class DiscountCodesCreateContainer extends React.Component {
    handleSubmitForm = (values) => {
        const {
            history,
            discountId,
            dispatchForm,
        } = this.props;

        values.discount_id = discountId;

        return new Promise((resolve) => {
            dispatchForm({
                onError: resolve,
                onSuccess: () => {
                    resolve(history.push(`/discounts/${ discountId }/discount-codes`));
                },
                values: values,
            });
        });
    }

    render() {
        const {
            discountId,
            translate,
        } = this.props;

        const breadcrumbs = [
            {
                label: translate('resources.discounts.title'),
                link: '/discounts',
            },
            {
                label: translate('resources.discount_codes.title'),
                link: `/discounts/${ discountId }/discount-codes`,
            },
            {
                label: translate('actions.create'),
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.discount_codes.actions.create') } />

                    <Actions>
                        <ListButton url={ `/discounts/${ discountId }/discounts-codes` } />
                    </Actions>
                </Header>

                <Card>
                    <CardText>
                        <DiscountCodesCreateForm
                            form='discount_codes_create'
                            handleSubmitForm={ this.handleSubmitForm }
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}

DiscountCodesCreateContainer.propTypes = {
    discountId: PropTypes.number.isRequired,
    dispatchForm: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (payload) => {
            payload.values = Object.assign({}, payload.values);

            if (payload.values.percentage) {
                payload.values.percentage = parseFloat(payload.values.percentage / 100);
            }

            if (payload.values.expiry_date) {
                payload.values.expiry_date = `${ payload.values.expiry_date } 23:59:59`;
            }

            dispatch(createDiscountCode(payload));
        },
    };
};

const enhance = compose(
    connect(
        null,
        mapDispatchToProps,
    ),
    translate,
);

export default enhance(DiscountCodesCreateContainer);



// WEBPACK FOOTER //
// ./src/pages/discountCodes/create/DiscountCodesCreateContainer.js